import PositionsScrollableList from 'components/Lists/ListView/PositionsScrollableList';
import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import React from 'react';
import { RequestEntity, IItemSubCategory } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DishesScrollView from './components/DishesScrollView';
import classNames from 'classnames';
import style from './Info.module.scss';

interface IItem {
	isOpenInfo: boolean;
	data: IItemSubCategory;
}

const Info: React.FC<IItem> = ({ isOpenInfo, data }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });

	const hiddenInRestaurants = data.restaurantsSubCategories.filter((el) => el.isHidden);
	const availableForRepetitionInRestaurants = data.restaurantsSubCategories.filter(
		(el) => el.isAvailableForRepetition,
	);

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.SubCategories}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						isMakeImageRequest={isOpenInfo}
						loaderSize="small"
					/>
				</div>
				<div className={style.infoContainer}>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="subcategoryLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="categoryLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.categoryName} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="customerLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.customerName} withTooltip={true} />
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="restaurantLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={data.restaurantsSubCategories} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="positionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<PositionsScrollableList restaurants={data.restaurantsSubCategories} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="isHiddenLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={hiddenInRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="availableForRepetitionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={availableForRepetitionInRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="dishesLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<DishesScrollView data={data.allDishes} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
